import { Spin } from "antd";
import { useTranslation } from 'react-i18next';

function GLoading() {
  const { t } = useTranslation();
  const defaultStyle: React.CSSProperties = {
    width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
  };

  return (
    <div style={defaultStyle}>
      <Spin tip={t('layout.Loading')} size="small"></Spin>
    </div>
  );
}

export default GLoading;
